// DEPRECATED
export const COLOR_BASE = '#799189';
export const COLOR_ACTION = '#afca0b';
export const COLOR_DARK70 = '#757575';
export const COLOR_SIGNAL = '#ee9e2d';
export const WEIGHT_S = 1;
export const WEIGHT_L = 4;
export const OPACITY_N = 0;
export const OPACITY_S = .2;
export const OPACITY_M = .5;
